module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo.8ec034ae.mp3";